export default __webpack_public_path__ + "static/media/header-poster1.f1fb9d95.jpg";